
















import { defineComponent, PropType } from "@vue/composition-api";
import { Tab } from "@/types";

export default defineComponent({
  name: "BaseSegmentedButton",
  props: {
    value: { required: true },
    tabs: { type: Array as PropType<Tab[]>, required: true },
    smallButton: { type: Boolean },
  },
});
